import { styles, variants, DialogTheme } from '../DialogStyles.css';
import { baseTheme } from './DialogBaseTheme.css';
import { multiVariantStyles } from './DialogVariants.css';

const DialogRedwoodTheme: DialogTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { DialogRedwoodTheme };
